import {
  Component,
  OnInit,
  Output,
  EventEmitter
} from "@angular/core";

@Component({
  selector: 'app-accept-electronic-signature',
  templateUrl: './accept-electronic-signature.component.html',
  styleUrls: ['./accept-electronic-signature.component.scss']
})
export class AcceptElectronicSignatureComponent implements OnInit {

  @Output() signatureTypeFormValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() signatureTypeSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  public optionSelected: boolean = false;
  public isDigitalSignatureSelected: boolean = false;
  public isTermAccepted = false;

  constructor() { }

  ngOnInit() { }

  radioChangeHandler(event: any) {
    this.optionSelected = JSON.parse(event.target.value);
    this.isDigitalSignatureSelected = event.target.checked;
    this.signatureTypeSelected.emit(this.optionSelected);
    this.emitFormValid();
  }

  setAcceptTerms(value: boolean) {
    this.isTermAccepted = value;
    this.emitFormValid();
  }

  emitFormValid() {
    if (this.isTermAccepted) {
      this.signatureTypeFormValid.emit(this.isDigitalSignatureSelected);
    } else {
      this.signatureTypeFormValid.emit(false);
    }
  }
}